import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { UserService } from '@/lib/services/userService'
import type { UserAvailabilityStatus } from '@/lib/userAvailability'

export type UserStatus = UserAvailabilityStatus

type UserStatusState = {
  status: UserStatus
  statusChangedAt: string | null
  setStatus: (status: UserStatus, onError?: (error: Error) => void) => Promise<void>
  setStatusChangedAt: (timestamp: string | null) => void
}

export const useUserStatusStore = create<UserStatusState>()(
  persist(
    (set) => ({
      status: 'online',
      statusChangedAt: null,
      setStatus: async (status: UserStatus, onError?: (error: Error) => void) => {
        try {
          const result = await UserService.updateStatus(status)
          if (result.success) {
            set({ status, statusChangedAt: result.status_changed_at })
          } else {
            const error = new Error(result.message || 'Failed to update status')
            if (onError) onError(error)
            else throw error
          }
        } catch (error: any) {
          if (onError) {
            onError(error instanceof Error ? error : new Error(error?.message || 'Failed to update status'))
          } else {
            throw error
          }
        }
      },
      setStatusChangedAt: (timestamp: string | null) => set({ statusChangedAt: timestamp }),
    }),
    {
      name: 'user-status-storage',
    }
  )
)
